import { render, staticRenderFns } from "./GBrandPreviewForm.vue?vue&type=template&id=bf17451c&scoped=true&"
import script from "./GBrandPreviewForm.vue?vue&type=script&lang=ts&"
export * from "./GBrandPreviewForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBrandPreviewForm.vue?vue&type=style&index=0&id=bf17451c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf17451c",
  null
  
)

export default component.exports